/* Helper to compute and apply overlay (fab -> search) positioning.
   Sets width - search stays centered and expands symmetrically.
   Prevents overlap with FAB by capping the width.
*/
export function applyOverlayPosition(
  fabEl: HTMLElement | null,
  overlayEl: HTMLElement | null,
  isSearchVisible: boolean
) {
  if (!overlayEl) return;

  const viewportWidth = window.innerWidth;

  if (isSearchVisible) {
    let desiredWidth = viewportWidth - 90;  // Leave room for avatar on left, FAB gap on right
    
    if (fabEl) {
      const fabRect = fabEl.getBoundingClientRect();
      const gapFromFab = 8;  // Reduced gap
      const maxRight = fabRect.left - gapFromFab;
      
      // Left edge at 16px from left (minimal margin, maximum width)
      const leftEdge = 16;
      const maxWidth = maxRight - leftEdge;
      
      desiredWidth = Math.max(200, maxWidth);
    }
    
    overlayEl.style.setProperty('--overlay-w', `${desiredWidth}px`);
    // Position it with left edge at 16px
    overlayEl.style.setProperty('--overlay-left', '16px');
  } else {
    overlayEl.style.setProperty('--overlay-w', '56px');
    // Center the collapsed circle by calculating exact pixel position
    const centerLeft = (viewportWidth / 2) - 28;
    overlayEl.style.setProperty('--overlay-left', `${centerLeft}px`);
  }
}

/* Helper for search-only overlay (no separate FAB button beside it).
   Full-width expansion with 16px margins each side. */
export function applySearchOverlayPosition(
  overlayEl: HTMLElement | null,
  isSearchVisible: boolean
) {
  if (!overlayEl) return;

  const viewportWidth = window.innerWidth;

  if (isSearchVisible) {
    overlayEl.style.setProperty('--overlay-w', `${viewportWidth - 32}px`);
    overlayEl.style.setProperty('--overlay-left', '16px');
  } else {
    overlayEl.style.setProperty('--overlay-w', '56px');
    const centerLeft = (viewportWidth / 2) - 28;
    overlayEl.style.setProperty('--overlay-left', `${centerLeft}px`);
  }
}

/** Read the real env(safe-area-inset-bottom) via a probe element.
 *  CSS custom properties containing env() can't be parsed via getComputedStyle. */
export function getIosSafeAreaBottom(): number {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:fixed;bottom:0;height:env(safe-area-inset-bottom,0px);pointer-events:none;visibility:hidden;';
  document.body.appendChild(probe);
  const value = probe.getBoundingClientRect().height;
  document.body.removeChild(probe);
  return value;
}

export default applyOverlayPosition;
